export const T = {
  en_GB: {
    searchPlaceholder: "Search by name or ISIN...",
    allTypes: "All Types",
    typesSelected: "type(s) selected",
    selectAll: "Select All",
    anyRiskTolerance: "Any Risk Tolerance",
    riskScoreFilter: "Risk score",
    anyTimeHorizon: "Any Time Horizon",
    productsFound: "product(s) found",
    tableHeaderName: "Name",
    tableHeaderIsin: "ISIN",
    tableHeaderType: "Type",
    tableHeaderMinRisk: "Min Risk Level",
    tableHeaderMinRiskScore: "Min Risk Score",
    tableHeaderMinHorizon: "Min Horizon",
    tableHeaderSuitable: "Suitable",
    noProductsMatch: "No products match your search criteria.",
    unknown: "Unknown",
    suitable: "Suitable",
    notSuitable: "Not suitable",
    clientClassifiedAs: "Client is classified as",
    autoSuitableForAll: "and is automatically suitable for all products.",
    suitabilityWarning: "Suitability Warning",
  },
  nb_NO: {
    searchPlaceholder: "Søk etter navn eller ISIN...",
    allTypes: "Alle typer",
    typesSelected: "type(r) valgt",
    selectAll: "Velg alle",
    anyRiskTolerance: "Alle risikotoleranser",
    riskScoreFilter: "Risikoscore",
    anyTimeHorizon: "Alle tidshorisonter",
    productsFound: "produkt(er) funnet",
    tableHeaderName: "Navn",
    tableHeaderIsin: "ISIN",
    tableHeaderType: "Type",
    tableHeaderMinRisk: "Min. risikonivå",
    tableHeaderMinRiskScore: "Min. risikoscore",
    tableHeaderMinHorizon: "Min horisont",
    tableHeaderSuitable: "Egnet",
    noProductsMatch: "Ingen produkter matcher søkekriteriene.",
    unknown: "Ukjent",
    suitable: "Egnet",
    notSuitable: "Ikke egnet",
    clientClassifiedAs: "Kunden er klassifisert som",
    autoSuitableForAll: "og er automatisk egnet for alle produkter.",
    suitabilityWarning: "Egnethetsadvarsel",
  },
} as const;
